import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import './App.css';

// Import our components
import PresentationView from './components/PresentationView';
import ClientView from './components/ClientView';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#EEF0F2',
    },
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ bgcolor: '#EEF0F2', minHeight: '100vh' }}>
        <Router>
          <Routes>
            <Route path="/" element={<PresentationView />} />
            <Route path="/client/:sessionId" element={<ClientView />} />
          </Routes>
        </Router>
      </Box>
    </ThemeProvider>
  );
};

export default App;
